// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb-container[data-v-7f4bd280]{display:flex;align-items:baseline}.breadcrumb-container[data-v-7f4bd280]  .el-breadcrumb__item{font-size:1.2rem}.breadcrumb-container[data-v-7f4bd280]  .el-breadcrumb__item *{font-weight:700!important}.breadcrumb-container[data-v-7f4bd280]  .is-link{color:#3369b2}.breadcrumb-container[data-v-7f4bd280]  .is-link:hover{color:#409eff}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
